import moment from "moment";

export function createColumns() {
  return [
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento"
    },
    {
      title: "Nombres",
      dataIndex: "nombre",
      key: "nombre"
    },
    {
      title: "Aula",
      dataIndex: "aula",
      key: "aula"
    },
    {
      title: "Fecha y hora",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (updatedAt) => {
        return <p>h. {moment(updatedAt).fromNow(true)}</p>;
      }
    }
  ];
}
